import {
  BalancePaymentMethodBank,
  BalancePaymentMethodCard,
  BalancePaymentMethodsApiResponse,
  PaymentMethodType,
} from 'src/types/Balance';

export type PaymentMethodItem =
  | { type: PaymentMethodType.CARD; item: BalancePaymentMethodCard }
  | { type: PaymentMethodType.BANK; item: BalancePaymentMethodBank };

export function getSortedPaymentMethods(
  response: BalancePaymentMethodsApiResponse | null
): PaymentMethodItem[] {
  if (!response) {
    return [];
  }

  const cards = response.cards;
  const banks = response.banks;

  const allMethods: PaymentMethodItem[] = [
    ...cards.map((item) => ({ type: PaymentMethodType.CARD as const, item })),
    ...banks.map((item) => ({ type: PaymentMethodType.BANK as const, item })),
  ];

  return allMethods.sort((a, b) => {
    if (a.item.isDefault && !b.item.isDefault) return -1;
    if (!a.item.isDefault && b.item.isDefault) return 1;
    return 0;
  });
}
